export const GET_ALL_CAMERAS_TYPE = 'getAllCameras';
export const CONFIGURATION_DIALOG_MODE = Object.freeze({
    NEW: 'new',
    EDIT: 'edit',
});
